import { ChangeAlertCallbackType } from "../components/Root";
import { getPosition } from "./PositionService";
import * as API from "../http/api";

export class ManualCheckService {
    private changeAlert: ChangeAlertCallbackType;
    constructor(changeAlert: ChangeAlertCallbackType) {
        this.changeAlert = changeAlert;
    }

    async afbClevelList(data) {
        const pos = getPosition();
        const response = await API.service("afbClevelList", data, pos, this.changeAlert, null, null);

        return response?.data;
    }

    async afbClevelFind(data) {
        const pos = getPosition();
        const response = await API.service("afbClevelFind", data, pos, this.changeAlert, null, null);

        return response?.data;
    }

    async afbClevelCreate(data) {
        const pos = getPosition();
        const response = await API.service("afbClevelCreate", data, pos, this.changeAlert, null, null);

        return response?.data;
    }

    async afbClevelUpdate(data) {
        const pos = getPosition();
        const response = await API.service("afbClevelUpdate", data, pos, this.changeAlert, null, null);

        return response?.data;
    }
}
